import {toAbsoluteUrl} from '../../../_gori/helpers'
import {CSSTransition} from 'react-transition-group'

export function AgreementPage() {
  const data = [
    {
      category: 'Label Alteration',
      action: 'Editing or recreating USPS labels using Photoshop or design tools.',
      description: 'Changing sender/recipient address, postage amount, or barcode image.',
    },
    {
      category: 'Duplicate Tracking Numbers',
      action: 'Reprinting or copying a valid USPS label to use for a second shipment.',
      description: 'Same tracking number used on multiple packages.',
    },
    {
      category: 'Unauthorized Generation',
      action: "Creating labels outside Gori's API or copying label data for third-party systems.",
      description: 'Downloading label data and reformatting it for reuse.',
    },
    {
      category: 'Falsified Postage Values',
      action: 'Manually adjusting postage indicators or inserting fake indicia.',
      description: 'Replacing "$9.85" with "$0.00" or blank area.',
    },
    {
      category: 'Reselling Labels',
      action: "Selling or transferring labels generated under Gori's account to others.",
      description: 'Issuing USPS labels to unrelated merchants.',
    },
    {
      category: 'Tampering with Weight/Service Class',
      action: 'Manipulating package weight, service type, or zone.',
      description: 'Declaring 10 lbs as 2 lbs to reduce postage.',
    },
    {
      category: 'Barcode Distortion',
      action: 'Altering barcode structure to evade USPS scanning.',
      description: 'Using filters, resizing, or overlaying graphics.',
    },
  ]

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundColor: '#E4EFEE',
        backgroundImage: `url(${toAbsoluteUrl('/media/gori/login/gori_bg_rocket_1.webp')})`,
      }}
    >
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='w-lg-1100px bg-transparent p-3 p-md-10 p-lg-15 mx-auto fade-appear-done fade-enter-done'>
          <div className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'>
            {/* title */}
            <div className='mt-10'>
              <div className='container'>
                <div className='justify-content-center d-flex mb-10'>
                  <img
                    src={toAbsoluteUrl('/media/logos/shipbae-black.svg')}
                    className=''
                    alt=''
                    style={{width: '240px'}}
                  />
                </div>
                <div className='justify-content-center d-flex mb-5'>
                  <div className='text-center fw-bolder fs-1'>Gori Company LLC</div>
                </div>
                <div className='justify-content-center d-flex mb-5'>
                  <div className='text-center fw-bolder fs-1'>
                    USPS Label Integrity and Compliance Agreement{' '}
                    <sup className='text-danger'>*</sup>
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className='pb-10 pt-5'>
              <div className='container mb-0 mb-md-10 fs-4 fs-md-2'>
                <div className='mt-5 mb-10'>
                  <p className='fw-bolder'>Effective Date: 18/11/2025</p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>Parties:</p>
                  <ul className='fw-bolder'>
                    <li>
                      Gori Company (PYK Global Inc.), a USPS Global Direct Entry (GDE) partner
                      (“Gori”), and
                    </li>
                    <li>
                      ShipBae User, including its affiliates, agents, and representatives
                      (“Customer”).
                    </li>
                  </ul>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>1. Purpose</p>
                  <p>
                    This Agreement is entered into to ensure full compliance with United States
                    Postal Service (USPS) regulations and to prevent the creation, alteration, or
                    use of fraudulent, duplicated, or otherwise invalid postage labels. <br />
                    Customer acknowledges that all USPS labels generated through Gori’s system are
                    issued under Gori’s GDE authorization, and misuse of such labels may subject
                    both parties to USPS investigation and penalties.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>2. Prohibited Conduct</p>
                  <p className='m-0'>Customer shall not, directly or indirectly:</p>
                  <ol className='m-0'>
                    <li>
                      Alter, edit, or modify USPS postage labels usin Photoshop, graphic software,
                      or any manual or automated means.
                    </li>
                    <li>
                      Reuse or reproduce USPS tracking numbers, barcodes, or postage data on
                      multiple packages.
                    </li>
                    <li>
                      Generate USPS labels outside of the authorized Gori system or USPS-certified
                      APIs.
                    </li>
                    <li>
                      Manipulate any label data including postage value, origin ZIP, class of
                      service, or weight.
                    </li>
                    <li>
                      Sell, share, or distribute any USPS labels to unauthorized third parties.
                    </li>
                  </ol>
                  <p className='m-0'>
                    Any such conduct will be considered a material breach of this Agreement.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>3. Label Generation and Verification</p>
                  <p className='m-0'>All USPS labels must be:</p>
                  <ul className='m-0'>
                    <li>Created through Gori’s secured platform or API,</li>
                    <li>Associated with a valid manifest, and</li>
                    <li>Fully paid at the time of manifest submission.</li>
                  </ul>
                  <p className='m-0'>
                    Gori reserves the right to audit label records, tracking data, and postage
                    transactions to ensure authenticity and compliance.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>4. Liability and Indemnification</p>
                  <p className='m-0'>
                    Customer acknowledges that USPS considers any alteration, duplication, or
                    falsification of postage to be postal fraud under 18 U.S.C. § 472–473.
                  </p>
                  <p className='m-0'>Accordingly:</p>
                  <ul className='m-0'>
                    <li>
                      Gori may immediately suspend or terminate Customer’s account upon detection of
                      suspected misuse.
                    </li>
                    <li>
                      Customer shall reimburse Gori and USPS for any assessed losses, penalties, or
                      damages resulting from non-compliance.
                    </li>
                    <li>
                      Customer shall indemnify and hold harmless Gori, its affiliates, and the USPS
                      against any claim, fine, or expense arising from misuse of postage labels
                      under Customer’s account.
                    </li>
                  </ul>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>5. Compliance Cooperation</p>
                  <p className='m-0'>
                    Customer agrees to cooperate with USPS or Gori investigations, including
                    providing documentation or shipment data upon request. <br />
                    Failure to cooperate may result in permanent suspension or revocation of USPS
                    label access.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>6. Term and Termination</p>
                  <p className='m-0'>
                    This Agreement shall remain in effect until terminated by either party upon
                    written notice. <br />
                    Termination shall not affect any rights or liabilities accrued prior to the
                    termination date.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>7. Governing Law</p>
                  <p className='m-0'>
                    This Agreement shall be governed by and construed in accordance with the laws of
                    the State of California, without regard to conflict of law principles.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>8. Acknowledgment and Acceptance</p>
                  <p className='m-0'>
                    By signing below, Customer acknowledges that they have read, understood, and
                    agreed to the terms of this Compliance Agreement and understand that violation
                    of these terms may result in immediate termination, forfeiture of funds, and
                    legal consequences.
                  </p>
                </div>

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>
                    Exhibit A – Examples of Prohibited USPS Label Activities
                  </p>
                  <p className='m-0'>
                    The following are examples of actions that constitute label tampering, misuse,
                    or fraud under this Agreement. This list is illustrative, not exhaustive.
                  </p>
                </div>

                {/* table */}
                <div className='mw-1100px bg-white fs-7 text-start mb-10'>
                  <div className='row g-0 border'>
                    <div className='col-12 col-md-4 bg-light border-end p-3'>
                      <h6 className='my-2 fw-bold text-center'>Category</h6>
                    </div>
                    <div className='col-12 col-md-4 bg-light border-end p-3'>
                      <h6 className='my-2 fw-bold text-center'>Prohibited Action</h6>
                    </div>
                    <div className='col-12 col-md-4 bg-light p-3'>
                      <h6 className='my-2 fw-bold text-center'>Example / Description</h6>
                    </div>
                  </div>

                  {data.map((item, index) => (
                    <div key={index} className='row g-0 border-start border-end border-bottom'>
                      <div className='col-12 col-md-4 border-end p-5 d-flex align-items-center justify-content-center'>
                        <div>{item.category}</div>
                      </div>
                      <div className='col-12 col-md-4 border-end p-5 text-start'>
                        <div>{item.action}</div>
                      </div>
                      <div className='col-12 col-md-4 p-5 text-start'>
                        <div>{item.description}</div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* end table */}

                <div className='mt-5 mb-10'>
                  <p className='fw-bolder m-0'>Enforcement Notice</p>
                  <p className='m-0'>
                    Any violation of these terms will result in immediate suspension of USPS label
                    access, reporting to USPS Postal Inspection Service, and legal action under
                    federal postal fraud statutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  )
}
